import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosComponent } from 'src/app/pago/containers/datos/datos.component';
import { NgbNavModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TarjetaDeCreditoComponent } from 'src/app/pago/containers/tarjeta-de-credito/tarjeta-de-credito.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormDatosOtraPersonaComponent } from 'src/app/pago/components/form-datos-otra-persona/form-datos-otra-persona.component';
import { SuraFormModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-form';
import { FormDatosTarjetaDeCreditoComponent } from 'src/app/pago/components/form-datos-tarjeta-de-credito/form-datos-tarjeta-de-credito.component';
import { ValidacionComponent } from 'src/app/pago/containers/validacion/validacion.component';
import { ERROR_MESSAGES } from 'src/app/pago/const/ErrorMessage.const';
import { PrismicGraphqlService } from '@segurosvoluntarios_vel/commons-services';
import { HttpClientModule } from '@angular/common/http';
import { ResumenDescuentosComponent } from 'src/app/pago/containers/resumen-descuentos/resumen-descuentos.component';
import { AprobadoComponent } from 'src/app/pago/containers/estado-pago/aprobado/aprobado.component';
import { RechazadoComponent } from 'src/app/pago/containers/estado-pago/rechazado/rechazado.component';
import { PendienteComponent } from 'src/app/pago/containers/estado-pago/pendiente/pendiente.component';
import { ResumenPagoComponent } from 'src/app/pago/components/resumen-pago/resumen-pago.component';
import { ModalErrorComponent } from 'src/app/pago/components/modal-error/modal-error.component';
import { SuraModalModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-modal';
import { CountdownModule } from 'ngx-countdown';
import { LoadingScreenModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-loading-screen';
import { OtroMedioDePagoComponent } from 'src/app/pago/components/otro-medio-de-pago/otro-medio-de-pago.component';
import { InputCheckComponent } from 'src/app/pago/components/input-check/input-check.component';
import { SwitchComponent } from 'src/app/pago/components/switch/switch.component';
import { ContenidoPagosService } from 'src/app/pago/services/contenido-pagos/contenido-pagos.service';
import { MaestrosService } from 'src/app/pago/services/maestros/maestros.service';
import { ResumenCompraComponent } from 'src/app/pago/components/resumen-compra/resumen-compra.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SuraFormModule.forRoot(ERROR_MESSAGES),
    NgbNavModule,
    NgbPopoverModule,
    HttpClientModule,
    SuraModalModule,
    CountdownModule,
    LoadingScreenModule,
  ],
  declarations: [
    DatosComponent,
    ResumenCompraComponent,
    TarjetaDeCreditoComponent,
    FormDatosOtraPersonaComponent,
    FormDatosTarjetaDeCreditoComponent,
    ValidacionComponent,
    ResumenDescuentosComponent,
    AprobadoComponent,
    RechazadoComponent,
    PendienteComponent,
    ResumenPagoComponent,
    ModalErrorComponent,
    SwitchComponent,
    OtroMedioDePagoComponent,
    InputCheckComponent,
  ],
  providers: [PrismicGraphqlService, MaestrosService, ContenidoPagosService],
})
export class PagoModule {}
